import { render, staticRenderFns } from "./AppMenuPageViewModal.vue?vue&type=template&id=eb790ed2&scoped=true"
import script from "./AppMenuPageViewModal.vue?vue&type=script&lang=js"
export * from "./AppMenuPageViewModal.vue?vue&type=script&lang=js"
import style0 from "./AppMenuPageViewModal.vue?vue&type=style&index=0&id=eb790ed2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb790ed2",
  null
  
)

export default component.exports